import { html, literal } from 'lit/static-html.js'
import { property } from 'lit/decorators.js'
import { ifDefined } from 'lit/directives/if-defined.js'

import { LfuiElement } from '#utils/element'

import styles from './lfds-section-header.css.ts'

const HEADING_TAGS = {
	h1: literal`h1`,
	h2: literal`h2`,
	h3: literal`h3`,
	h4: literal`h4`,
	h5: literal`h5`,
	h6: literal`h6`
} as const

type HeadingLevel = keyof typeof HEADING_TAGS

/**
 * @name LfdsSectionHeader
 *
 * @status ready
 * @tag lfds-section-header
 * @slot default - Heading content rendered inside the internal heading element (h1-h6 via level)
 */
export default class LfdsSectionHeader extends LfuiElement {
	static styles = [LfuiElement.styles, styles]

	@property() level: HeadingLevel = 'h2'
	@property({ attribute: 'sr-label' }) srLabel?: string

	render() {
		const tag = HEADING_TAGS[this.level] ?? HEADING_TAGS.h2

		return html`
			<${tag}
				aria-label=${ifDefined(this.srLabel || undefined)}
			>
				<slot></slot>
			</${tag}>
		`
	}
}
